import { compress, decompress } from 'lz-string';

export default class storageApi {
  constructor(storage) {
    this.storage = storage;
  }

  getLocalStorage() {
    return this.storage.local;
  }

  setItem(key, value) {
    if (typeof value === 'string') {
      const compressed = compress(value);
      return this.getLocalStorage().setItem(key, compressed);
    } else {
      console.error('setItem: value is not string', value);
    }
  }

  getItem(key) {
    const value = this.getLocalStorage().getItem(key);
    if (value) {
      const decompressed = decompress(value);
      return decompressed;
    }
    return value;
  }

  removeItem(key) {
    return this.getLocalStorage().removeItem(key);
  }

  clear(key) {
    return this.getLocalStorage().clear(key);
  }
}
